import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  LinkComponent,
  ReasonsArrayDisplay,
  ResolveInvestigationCases
} from "../../core/et3-table/UserCustomHelpers";
import WarningButton from "../../core/et3-shared-components/action-buttons/WarningButton";
import TempBanButton from "../../core/et3-shared-components/action-buttons/TempBanButton";
import BanButton from "../../core/et3-shared-components/action-buttons/BanButton";
import SilentBanButton from "../../core/et3-shared-components/action-buttons/SilentBanButton";
import { isPositiveNumber, reduce } from "et3-type-guards";
import { SILENT_BANNED_FLAG } from "../input-entries-constants";

export const INVESTIGATION_CASES_HEADERS: GridColDef[] = [
  {
    headerName: "ID",
    field: "id",
    width: 50
  },
  {
    headerName: "User ID",
    field: "user_id",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <LinkComponent
          href={`/users/advanced?id=${params.row.user_id}`}
          text={`${params.row.user_id}`}
          style={{}}
        />
      );
    },
    width: 50
  },
  {
    headerName: "M/F",
    field: "gender",
    width: 40
  },
  {
    headerName: "Action",
    field: "action_type"
  },
  {
    headerName: "CSR",
    field: "CSR"
  },
  {
    headerName: "Reasons",
    field: "investigation_cases_reasons",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <ReasonsArrayDisplay reasons={params.row.investigation_cases_reasons} />
      );
    }
  },
  {
    headerName: "Date",
    field: "created_on"
  },
  {
    headerName: "Warn",
    field: "warn",
    renderCell: (params: GridValueGetterParams) => {
      const userID = params.row.user_id;
      const userUUID = params.row.userUUID;
      const investigationID = params.row.resolve.invResolveInvestigationId;
      const isUserReported = isPositiveNumber(params.row.isUserReported);
      return (
        <WarningButton
          fromPage="INVESTIGATION_CASES"
          extraData={{
            userUUID,
            userID,
            secondPartyID: investigationID,
            reportID: -1,
            reportedID: -1,
            reportedUUID: ""
          }}
          disabled={isUserReported}
          style={{}}
          size={"DEFAULT"}
        />
      );
    },
    width: 150
  },
  {
    headerName: "TB",
    field: "temporary_ban",
    renderCell: (params: GridValueGetterParams) => {
      const userID = params.row.user_id;
      const userUUID = params.row.userUUID;
      const investigationID = params.row.resolve.invResolveInvestigationId;
      const isUserReported = isPositiveNumber(params.row.isUserReported);
      return (
        <TempBanButton
          fromPage="INVESTIGATION_CASES"
          extraData={{
            userID,
            userUUID,
            secondPartyID: investigationID,
            reportID: -1,
            reportedID: -1,
            reportedUUID: ""
          }}
          disabled={isUserReported}
          size={"DEFAULT"}
        />
      );
    },
    width: 180
  },
  {
    headerName: "Ban",
    field: "ban",
    renderCell: (params: GridValueGetterParams) => {
      const userID = params.row.user_id;
      const userUUID = params.row.userUUID;
      const investigationID = params.row.resolve.invResolveInvestigationId;
      const isUserReported = isPositiveNumber(params.row.isUserReported);
      return (
        <BanButton
          extraData={{
            userID,
            userUUID,
            secondPartyID: investigationID,
            reportID: -1,
            reportedID: -1,
            reportedUUID: ""
          }}
          fromPage="INVESTIGATION_CASES"
          disabled={isUserReported}
          size={"DEFAULT"}
        />
      );
    },
    width: 130
  },
  {
    headerName: "Silent Ban",
    field: "silent_ban",
    renderCell: (params: GridValueGetterParams) => {
      const userID = params.row.user_id;
      const userUUID = params.row.userUUID;
      const investigationID = params.row.resolve.invResolveInvestigationId;
      const isUserReported = isPositiveNumber(params.row.isUserReported);
      const isUserSilentBanned =
        reduce(() => params.row.isSilentBanned, 0) === SILENT_BANNED_FLAG;
      return (
        <SilentBanButton
          extraData={{
            userID,
            userUUID,
            secondPartyID: investigationID,
            reportID: -1,
            reportedID: -1,
            reportedUUID: ""
          }}
          fromPage="INVESTIGATION_CASES"
          disabled={isUserReported || isUserSilentBanned}
          size={"DEFAULT"}
        />
      );
    },
    width: 150
  },
  {
    headerName: "Resolve",
    field: "resolve",
    renderCell: (params: GridValueGetterParams) => {
      const {
        invResolveInvestigationId,
        invResolveReasons,
        invResolveUserUUID
      } = params.row.resolve;
      return (
        <ResolveInvestigationCases
          invResolveInvestigationId={invResolveInvestigationId}
          invResolveUserUUID={invResolveUserUUID}
          invResolveReasons={invResolveReasons}
        />
      );
    },
    width: 130
  }
];
